import { render } from "./ActiveMembers.vue?vue&type=template&id=52c0e2b2&scoped=true"
import script from "./ActiveMembers.vue?vue&type=script&lang=js"
export * from "./ActiveMembers.vue?vue&type=script&lang=js"

import "./ActiveMembers.vue?vue&type=style&index=0&id=52c0e2b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c0e2b2"]])

export default __exports__